/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-filename-extension */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import { format } from 'date-fns';

import PropTypes from 'prop-types';
import { BoxShadow } from '../../../../../shared/GlobalStyles';
import iconSet from '../../../../../shared/images/teambuildr-selection.json';
import {
  setDuplicateModalShowing as setDuplicateSCModalShowing,
  duplicateDashboard,
} from '../../../../sport-coach-dashboard/ducks/sportCoachDashboardActions';
import Button from '../../../../../shared/_TBComponents/Button';
import { dashboardTracker } from '../../../../../shared/utils/amplitudeHelper';
import SharedTemplateModalContainer from './SharedTemplateModalContainer';
import {
  duplicateLMDashboard,
  setDuplicateLMDashModal,
} from '../../../../load-monitoring-dashboard/ducks/loadMonitoringDashboardActions';
import {
  duplicateFPDashboard,
  setDuplicateFPDashModal,
} from '../../../../force-plate-dashboard/ducks/forcePlateDashboardActions';
import {
  duplicateVTTemplate,
  setDuplicateVTDashModal,
} from '../../../../volume-tracker-dashboard/ducks/volumeTrackerDashboardActions';
import { duplicateVBTTemplate, setDuplicateVBTDashModal } from '../../../../vbt-dashboard/ducks/vbtDashboardActions';
import SharedInput from '../../../../../shared/_TBComponents/Input';

const ModalContainer = styled('div')`
  z-index: 1003;
  min-height: 270px;
  width: 50vw;
  overflow: auto;
  @media only screen and (max-width: 768px) {
    width: 90vw;
  }
  min-width: 430px;
  max-width: 600px;
  max-height: calc(100vh - 20px);
  position: absolute;
  border-radius: 12px;
  left: 50%;
  top: 50%;
  right: 50%;
  transition: all 0.3s linear, opacity 0.3s ease-out;
  opacity: ${(props) => (props.isActive ? '1' : '0')};
  visibility: ${(props) => (props.isActive ? 'visible' : 'hidden')};
  transform: ${(props) => (props.isActive ? 'translate(-50%,-50%)' : 'translate(-50%, 300%)')};
  user-select: none;
`;

const RemoveDiv = styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  z-index: 1001;
  color: ${(props) => (props.isDarkMode ? 'white' : '#444444')};
  background: white;
  .remove-div-icon {
    cursor: pointer;
  }
`;

const ContentContainer = styled('div')`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding-left: 40px;
  padding-right: 40px;
  max-height: ${(props) => props.customHeight};
  margin-bottom: 25px;
  transition: max-height 0.5s linear;
`;

const ModalHeader = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 40px;
`;

const HeaderIconContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid black;
  height: 52px;
  width: 52px;
  border-radius: 50%;
`;

const ModalHeaderText = styled('div')`
  font-size: 24px;
  font-family: 'Nunito Sans';
  font-weight: 400;
  margin-top: 10px;
`;

const SlidesContainer = styled('div')`
  overflow: hidden;
  width: 100%;
  max-height: ${(props) => props.customHeight};
  transition: max-height 1s linear;
`;

const Slides = styled('div')`
  white-space: nowrap;
  transition: transform 0.5s ease;
  transform: ${(props) => `translateX(-${props.activeSlide * 100}%)`};
  height: 100%;
`;

const Slide = styled('div')`
  width: 100%;
  display: inline-flex;
  flex-direction: column;
  height: 100%;
`;

const PortalContainer = styled('div')`
  width: 100%;
  background: white;
  box-shadow: ${BoxShadow};
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  overflow: auto;
`;

const ErrorBox = styled('div')`
  display: flex;
  flex-direction: column;
`;

const MappedError = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 14px;
  color: #c0392b;
`;

const ButtonContainer = styled('div')`
  border-radius: 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: white;
`;

const RelativePortalContainer = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const SharedTemplateDuplicateModal = ({ dashboard, legacyName }) => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const timestamp = format(new Date(), 'MMM d, yyyy hh:mm a');

  let duplicateTemplate = {};
  let isModalShowing = false;
  let setDuplicateModalShowing = () => {};
  let activeTemplate = null;
  let handleDuplicateTemplate = () => {};

  if (dashboard === 'Load Monitoring') {
    duplicateTemplate = useSelector(
      (state) => state.loadMonitoringDashboard.data.duplicateTemplate,
    );
    isModalShowing = useSelector(
      (state) => state.loadMonitoringDashboard.ui.duplicateModalShowing,
    );
    setDuplicateModalShowing = setDuplicateLMDashModal;
    activeTemplate = useSelector(
      (state) => state.loadMonitoringDashboard.data.activeTemplate,
    );
    handleDuplicateTemplate = duplicateLMDashboard;
  }

  if (dashboard === 'Force Plate') {
    duplicateTemplate = useSelector(
      (state) => state.forcePlateDashboard.data.duplicateTemplate,
    );
    isModalShowing = useSelector(
      (state) => state.forcePlateDashboard.ui.duplicateModalShowing,
    );
    setDuplicateModalShowing = setDuplicateFPDashModal;
    activeTemplate = useSelector(
      (state) => state.forcePlateDashboard.data.activeTemplate,
    );
    handleDuplicateTemplate = duplicateFPDashboard;
  }

  if (dashboard === 'KPI Tracker') {
    duplicateTemplate = useSelector(
      (state) => state.sportCoachDashboard.data.dupTemplate,
    );
    isModalShowing = useSelector(
      (state) => state.sportCoachDashboard.ui.duplicateDashboardModalShowing,
    );
    setDuplicateModalShowing = setDuplicateSCModalShowing;
    activeTemplate = useSelector(
      (state) => state.sportCoachDashboard.data.template,
    );
    handleDuplicateTemplate = duplicateDashboard;
  }

  if (dashboard === 'Volume Tracker') {
    duplicateTemplate = useSelector(
      (state) => state.volumeTrackerDashboard.data.duplicateTemplate,
    );
    isModalShowing = useSelector(
      (state) => state.volumeTrackerDashboard.ui.duplicateModalShowing,
    );
    setDuplicateModalShowing = setDuplicateVTDashModal;
    activeTemplate = useSelector(
      (state) => state.volumeTrackerDashboard.data.activeTemplate,
    );
    handleDuplicateTemplate = duplicateVTTemplate;
  }

  if (dashboard === 'VBT') {
    activeTemplate = useSelector(
      (state) => state.vbtDashboard.data.activeTemplate,
    );
    duplicateTemplate = useSelector(
      (state) => state.vbtDashboard.data.duplicateTemplate,
    );
    handleDuplicateTemplate = duplicateVBTTemplate;
    isModalShowing = useSelector(
      (state) => state.vbtDashboard.ui.duplicateModalShowing,
    );
    setDuplicateModalShowing = setDuplicateVBTDashModal;
  }

  const [dashDescription, setDashDescription] = useState('');
  const [dashTitle, setDashTitle] = useState('');
  const [errors, setErrors] = useState({
    errorsExist: true,
    errors: [
      {
        error: 'title error',
        msg: 'You must add a dashboard title',
        isShowing: false,
      },
      {
        error: 'incomplete item error',
        msg: 'Some evaluation items are incomplete',
        isShowing: false,
      },
      {
        error: 'API error',
        msg:
          'There was an issue duplicating the dashboard, please check the form and try again.',
        isShowing: false,
      },
    ],
  });

  const generateTitle = (originalTitle = '', maxLength = 50) => {
    const prefix = 'Copy of ';
    const timestampSuffix = ` (${timestamp})`;
    const availableLength = maxLength - prefix.length - timestampSuffix.length;

    const trimmedTitle = originalTitle.slice(0, availableLength);
    return `${prefix}${trimmedTitle}${timestampSuffix}`;
  };

  useEffect(() => {
    if (isModalShowing === false) {
      setErrors({
        errorsExist: true,
        errors: [
          {
            error: 'title error',
            msg: 'You must add a dashboard title',
            isShowing: false,
          },
          {
            error: 'incomplete item error',
            msg: 'Some evaluation items are incomplete',
            isShowing: false,
          },
          {
            error: 'API error',
            msg:
              'There was an issue duplicating the dashboard, please check the form and try again.',
            isShowing: false,
          },
        ],
      });
    } else {
      const duplicateTitle = generateTitle(duplicateTemplate?.title || activeTemplate?.title);
      const duplicateDesc = duplicateTemplate?.description || activeTemplate?.description;
      setDashTitle(duplicateTitle);
      setDashDescription(duplicateDesc || '');
    }
  }, [isModalShowing]);

  const templateId = activeTemplate
    ? activeTemplate?.templateId
    : duplicateTemplate?.templateId;

  const handleClose = () => {
    dispatch(setDuplicateModalShowing(false));
    setDashTitle('');
    setDashDescription('');
  };

  const handleSubmit = () => {
    if (dashTitle.length) {
      const submissionObj = {
        title: dashTitle,
        description: dashDescription,
      };
      // Amplitude tracking
      dashboardTracker(
        `${legacyName} Dashboard`,
        'Duplicate Saved Dashboard',
        'Dashboard duplicated',
      );
      dispatch(
        handleDuplicateTemplate(
          currentUser.accountCode,
          templateId,
          submissionObj,
        ),
      );
      handleClose();
    } else {
      const newErrors = { ...errors };
      newErrors.errors[0].isShowing = true;
      setErrors(newErrors);
    }
  };

  console.log('isModalShowing', isModalShowing);

  return (
    <>
      <ModalContainer
        isActive={isModalShowing}
        customWidth='1000px'
        customHeight='1000px'
      >
        <RelativePortalContainer>
          <ButtonContainer>
            <div />
            <PortalContainer>
              <RemoveDiv>
                <ModalHeader>
                  <HeaderIconContainer>
                    <IcomoonReact iconSet={iconSet} size={20} icon='copy' />
                  </HeaderIconContainer>
                  <ModalHeaderText>Duplicate Dashboard</ModalHeaderText>
                  <ErrorBox>
                    {errors.errors[0].isShowing ? (
                      <MappedError>{errors.errors[0].msg}</MappedError>
                    ) : null}
                    {errors.errors[1].isShowing ? (
                      <MappedError>{errors.errors[1].msg}</MappedError>
                    ) : null}
                    {errors.errors[2].isShowing ? (
                      <MappedError>{errors.errors[2].msg}</MappedError>
                    ) : null}
                  </ErrorBox>
                </ModalHeader>
                <div className='remove-div-icon' onClick={handleClose}>
                  <IcomoonReact
                    iconSet={iconSet}
                    size={15}
                    icon='remove'
                    color='black'
                  />
                </div>
              </RemoveDiv>
              <ContentContainer customHeight='500px'>
                <SlidesContainer customHeight='auto'>
                  <Slides activeSlide={0}>
                    <Slide>
                      <SharedInput
                        charLimit={50}
                        fontSize='unset'
                        fontWeight={400}
                        height='40px'
                        label='Title'
                        name='dashTitle'
                        onBlur={() => {
                          if (!dashTitle.length) {
                            const newErrors = { ...errors };
                            newErrors.errors[0].isShowing = true;
                            setErrors(newErrors);
                          }
                        }}
                        onChange={(e) => {
                          if (e.target.value.length <= 50) {
                            if (
                              errors.errors[0].isShowing
                              && e.target.value.length
                            ) {
                              const newErrors = { ...errors };
                              newErrors.errors[0].isShowing = false;
                              setErrors(newErrors);
                            }
                            setDashTitle(e.target.value);
                          }
                        }}
                        placeholder='Title'
                        placeHolderColor='#444444'
                        styledPropsLabel={{
                          marginBottom: 'unset',
                          fontSize: '16px',
                        }}
                        styledPropsWrapper={{
                          display: 'flex',
                          flexDirection: 'column',
                          margin: '10px 0px',
                        }}
                        textColor='#444444'
                        value={dashTitle}
                      />
                      <SharedInput
                        charLimit={500}
                        fontSize='unset'
                        fontWeight={400}
                        height='75px'
                        isTextArea
                        label='Description'
                        name='dashDescription'
                        onChange={(e) => {
                          if (e.target.value.length <= 500) {
                            setDashDescription(e.target.value);
                          }
                        }}
                        placeholder='Description (optional)'
                        placeHolderColor='#444444'
                        styledPropsLabel={{
                          marginBottom: 'unset',
                          fontSize: '16px',
                        }}
                        styledPropsWrapper={{
                          display: 'flex',
                          flexDirection: 'column',
                          margin: '10px 0px',
                        }}
                        textColor='#444444'
                        value={dashDescription}
                      />
                    </Slide>
                  </Slides>
                </SlidesContainer>
              </ContentContainer>
            </PortalContainer>
            <Button
              bgColor='#424242'
              bottom
              fontSize='14px'
              fullWidth
              large
              name='Submit'
              noBorder
              onClick={handleSubmit}
              square
              styledWrapperProps={{
                borderBottomLeftRadius: '12px',
                borderBottomRightRadius: '12px',
              }}
              txtColor='#FFFFFF'
              upperCase
            />
          </ButtonContainer>
        </RelativePortalContainer>
      </ModalContainer>
      <SharedTemplateModalContainer
        isModalShowing={isModalShowing}
        onClose={handleClose}
      />
    </>
  );
};

SharedTemplateDuplicateModal.defaultProps = {
  dashboard: 'Wearables',
  legacyName: 'Wearables',
};

SharedTemplateDuplicateModal.propTypes = {
  dashboard: PropTypes.string,
  legacyName: PropTypes.string,
};

export default SharedTemplateDuplicateModal;
